var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#6373A4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.366 16.116a1.25 1.25 0 000 1.768l14.75 14.75a1.25 1.25 0 001.768 0l14.75-14.75a1.25 1.25 0 00-1.768-1.768L24 29.982 10.134 16.116a1.25 1.25 0 00-1.768 0z",
    fill: "#6373A4"
  })));
}
export default SvgCaretDown;